export default "__VITE_ASSET__CB$mLimJ__"